/*
 *
 * Widgets actions
 *
 */

import {
  FETCH_WIDGET,
  FETCH_WIDGET_SUCCESS,
  UPDATE_WIDGET_SUCCESS,
  FETCH_WIDGET_FAILURE,
  EXPORT_WIDGET,
  REMOVE_WIDGET,
  RESET_WIDGETS,
} from './constants';

export const fetchTeamWidget = (
  teamId,
  widgetID,
  pageSize,
  currentPage,
  sorting,
  filters,
  isPreview
) => ({
  type: FETCH_WIDGET,
  teamId,
  widgetID,
  pageSize,
  currentPage,
  sorting,
  filters,
  isPreview,
});

export const fetchTeamWidgetSuccess = (
  widgetID,
  executedWidget,
  definition
) => ({
  type: FETCH_WIDGET_SUCCESS,
  widgetID,
  executedWidget,
  definition,
});

export const updateWidgetSuccess = (widgetID, widget) => ({
  type: UPDATE_WIDGET_SUCCESS,
  widgetID,
  widget,
});
export const fetchTeamWidgetFailure = (widgetID, error) => ({
  type: FETCH_WIDGET_FAILURE,
  widgetID,
  error,
});

export const exportWidget = (teamID, widgetID, definition = {}) => ({
  type: EXPORT_WIDGET,
  teamID,
  widgetID,
  definition,
});

export const removeWidget = (widgetID) => ({
  type: REMOVE_WIDGET,
  widgetID,
});
export const resetWidgets = () => ({
  type: RESET_WIDGETS,
});
